<template>
    <div class="user-data-graph">
        <div style="width:600px;height:400px" ref="chart"></div>
    </div>
</template>

<script>
export default {
  name: 'userDataGraph',
  data () {
    return {
      xAxisData: ['大闸蟹', '大螃蟹', '小龙虾', '河蟹', '螃蟹'], // 横坐标
      seriesData: [300, 400, 300, 500, 100]// 纵坐标
    }
  },
  mounted () {
    this.initCharts()
  },
  methods: {
    initCharts () {
      const myChart = this.$echarts.init(this.$refs.chart)
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          data: this.$data.xAxisData
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: this.$data.seriesData
        }]
      })
    }
  }
}
</script>

<style scoped>
.user-data-graph{
  background-color: #fff;
  border-radius: 10px;
}
</style>
